import { render, staticRenderFns } from "./user-request.vue?vue&type=template&id=8ffebf68&"
import script from "./user-request.vue?vue&type=script&lang=js&"
export * from "./user-request.vue?vue&type=script&lang=js&"
import style0 from "./user-request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports